import { createLogService } from './log-service'

export const logService = createLogService()
